import React, { useState } from 'react';
import { Typography, logUserEvent, MuiTooltip, Iconography } from 'fmc-digital-common';
import { HStack } from 'native-base';
import { amplifyLogs } from '../../../amplifyLogs';
import { TaskConstants } from '../../../constants';
import { FilterDropDown } from '../../molecules';
const TableTitle = ({
  title,
  filterText,
  getSelectedFilter,
  initialFilter,
  taskCount,
  dynamicFilterLabel
}) => {
  const [selectedFilter, setSelectedFilter] = useState(initialFilter ? initialFilter : '');
  let showFilterText = '';
  if (taskCount && taskCount > 0) {
    showFilterText = `${selectedFilter} (${taskCount})`;
  } else {
    showFilterText = `${selectedFilter} (0)`;
  }
  return /*#__PURE__*/React.createElement(HStack, {
    w: '100%',
    justifyContent: 'space-between',
    p: 4,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: "lightBlue.400",
    backgroundColor: 'white.500',
    key: taskCount,
    testID: "table-title-container"
  }, /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Typography, {
    testID: "tableTitle",
    variant: "title2",
    color: "darkGray.900",
    accessibilityLabel: `${title}`,
    accessibilityRole: "text"
  }, title), /*#__PURE__*/React.createElement(MuiTooltip, {
    title: TaskConstants.TasksInfoMessage,
    "data-testid": "table-info-message"
  }, /*#__PURE__*/React.createElement(Iconography, {
    name: "info",
    size: 24,
    color: "primary.500"
  }))), initialFilter ? /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center',
    space: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "captionBold",
    textTransform: 'uppercase',
    testID: "filterText",
    accessibilityLabel: `${filterText}`,
    accessibilityRole: "text",
    color: "darkGray.900"
  }, filterText), /*#__PURE__*/React.createElement(HStack, {
    accessibilityLabel: `${selectedFilter}filter`,
    accessibilityRole: "menuitem",
    testID: selectedFilter
  }, /*#__PURE__*/React.createElement(FilterDropDown, {
    options: dynamicFilterLabel,
    onSelect: function (value) {
      logUserEvent(amplifyLogs.filterByDropdown);
      setSelectedFilter(value);
      getSelectedFilter(value);
    },
    initialFilter: showFilterText
  }))) : '');
};
export default TableTitle;
//# sourceMappingURL=index.js.map